import { createFileRoute } from '@tanstack/react-router';

import { PublishingTab } from '../../features/personal/PublishingTab';

/**
 * `/personal/publishing` = النشر (خطة القسم الشخصي ش4).
 *
 * **كان تبويبًا في المفكرة حتى 2026-09-23**، فحذفه المالك من هناك: «يكفي وجود
 * النشر في الفلتر الخاص بالتدوينات (مسودات، منشورة)». والشاشة تبقى بمسارها
 * لأن **ورشة الكتابة تكتب فيها**: زرّ «تم — احفظها فكرة» يُنشئ `publishing_post`
 * ثم يعرض رابط «افتحها». فحذفُ السطح كان سيجعل ما تحفظه الورشة بلا موضعٍ يُقرأ
 * فيه — كتابةٌ بلا قارئ.
 */
export const Route = createFileRoute('/personal/publishing')({ component: PublishingScreen });

function PublishingScreen() {
  return (
    <section className="flex flex-col gap-5">
      <header className="flex flex-col gap-1">
        <span className="eyebrow">شخصي</span>
        <h1 className="text-display">النشر</h1>
      </header>
      <PublishingTab />
    </section>
  );
}
